import { render } from "./UpdatePassword.vue?vue&type=template&id=3ef2466e&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=3ef2466e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef2466e"]])

export default __exports__